export default __webpack_public_path__ + "static/media/1031.9bbc1d2e.png";